import styled, { css } from 'styled-components';

import { BonusStage } from '@/api/common';

import { device, hexToRGB } from '@/styles/helpers';

export const ScTr = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  text-align: center;
  position: relative;
  padding-bottom: 4px;

  @media (${device.mobile}) {
    padding-bottom: 8px;
    grid-template-columns: repeat(1, 1fr);
  }

  & .th {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.14px;

    text-align: center;
    color: ${({ theme }) => theme.whiteColor};

    @media (${device.mobile}) {
      display: none;
    }
  }

  & span {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.14px;

    letter-spacing: 0em;
    text-align: center;
    color: ${({ theme }) => theme.whiteColor};

    & .mobile-title {
      display: none;
      @media (${device.mobile}) {
        display: inline;
        margin-right: 8px;
        font-weight: 700;
      }
    }

    @media (${device.mobile}) {
      text-align: start;

      &.stage {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
      }
    }
  }
`;

export const ScTable = styled.div`
  display: grid;
  gap: 4px;
  width: 100%;

  @media (${device.mobile}) {
    gap: 8px;
  }

  & .body {
    display: grid;
    gap: 4px;

    ${ScTr} {
      &:not(:last-child) {
        border-bottom: ${({ theme }) =>
          `1px solid ${hexToRGB(theme.whiteColor, 0.2)}`};
      }
    }
  }
`;

interface ScBonusStatusLabelProps {
  status: BonusStage;
}

export const ScBonusStatusLabel = styled.div<ScBonusStatusLabelProps>`
  padding: 3px 8px;
  width: fit-content;
  border-radius: 360px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
  }

  @media (max-width: 360px) {
    padding: 3px 6px;

    span {
      font-size: 10px;
      line-height: 13px;
    }
  }

  ${({ status, theme }) => {
    switch (status) {
      case BonusStage.Expired:
      case BonusStage.Canceled:
      case BonusStage.Lost:
        return css`
          background-color: ${hexToRGB(theme.redColor, 0.2)};
          span {
            color: ${theme.redColor};
          }
        `;
      case BonusStage.WagerDone:
      case BonusStage.Activated:
      case BonusStage.Issued:
        return css`
          background-color: ${hexToRGB(theme.greenColor, 0.2)};
          span {
            color: ${theme.greenColor};
          }
        `;
      case BonusStage.HandleBets:
      default:
        return css`
          background-color: ${hexToRGB(theme.yellowColor, 0.2)};
          span {
            color: ${theme.yellowColor};
          }
        `;
    }
  }};
`;
